import { render, staticRenderFns } from "./KanbanContent.vue?vue&type=template&id=33ebbd16&scoped=true&"
import script from "./KanbanContent.vue?vue&type=script&lang=js&"
export * from "./KanbanContent.vue?vue&type=script&lang=js&"
import style0 from "./KanbanContent.vue?vue&type=style&index=0&id=33ebbd16&lang=stylus&scoped=true&"
import style1 from "./KanbanContent.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ebbd16",
  null
  
)

export default component.exports